
// check https://mui.com/components/modal/ to do popups

import React, { useState,  useRef} from 'react';
import ShowChartIcon from '@mui/icons-material/ShowChart';
// material
import {
    Card, 
    Stack,
    Box,
    Divider,
    Typography,
    Grid,
    IconButton,
    //Chip,
    Container,
    Tooltip,
    Button,
    //Avatar,
    List,
    ListItem,
    //ListItemIcon,
    ListItemText,
} from '@mui/material';

import '../planos/Carrousel.css';

import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';

import DeleteIcon from '@mui/icons-material/Delete';

import VerExPopUp from '../popUps/VerExPopUp'
import EditExerc from '../popUps/EditExerc'
import DeleteExerc from '../popUps/DeleteExerc'
import ChangeOrderExs from '../popUps/ChangeOrderExs'

import { Icon } from '@iconify/react';
import dataViewAlt from '@iconify/icons-carbon/data-view-alt';

import RepeatIcon from '@mui/icons-material/Repeat';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TimerIcon from '@mui/icons-material/Timer';

import ArrowCircleRightSharpIcon from '@mui/icons-material/ArrowCircleRightSharp';
import ArrowCircleLeftSharpIcon from '@mui/icons-material/ArrowCircleLeftSharp';

import DashEx from '../popUps/DashEx';

import dadosSessoes from './DadosSessoes'

import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';

import {ImageBackdrop, ImageSrc} from '../imageButton';

import ArrowCircleDownOutlinedIcon from '@mui/icons-material/ArrowCircleDownOutlined';
import AddNewSession from '../popUps/AddNewSession';
import DeleteSessaoUtente from '../popUps/DeleteSessaoUtente';
import AddExsSessaoUtente from '../popUps/AddExsSessaoUtente';

import { makeStyles, withStyles } from "@mui/styles";
import { alpha, useTheme } from '@mui/material/styles';

/*
import { makeStyles, withStyles } from '@material-ui/styles';
import { useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
*/

const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      backgroundColor: "#fff",//theme.palette.background.paper
    }
  }));

export default function SessoesUtente() {
   const theme = useTheme();

   const MuiListItem = withStyles({
    root: {
      "&$selected": {
        backgroundColor: alpha(theme.palette.primary.main, 0.32),
        color: theme.palette.text.secondary,
        borderRadius: '60px 60px 60px 60px',
      },
      "&$selected:hover": {
        backgroundColor: alpha(theme.palette.primary.main, 0.2),
        color: "primary.main",
        borderRadius: '60px 60px 60px 60px',
      },
      "&:hover": {
        backgroundColor: alpha(theme.palette.primary.main, 0.05),
        color: "primary.main",
        borderRadius: '60px 60px 60px 60px',
      },
      color: theme.palette.text.secondary,
    },
    selected: {},

  })(ListItem);

    const classes = useStyles();
    const [selectedIndex, setSelectedIndex] = React.useState(0);

   const carousel = useRef(null);

   const handleLeftClick = (e) =>{
    e.preventDefault();
    console.log(carousel.current.offsetWidth);
    carousel.current.scrollLeft -= carousel.current.offsetWidth;
    }

    const handleRightClick = (e) =>{
        e.preventDefault();
        console.log(carousel.current.offsetWidth);
        carousel.current.scrollLeft += carousel.current.offsetWidth;
    }

    const [addSessaoPopUp, setAddSessaoPopUp] = useState(false);

    const [deleteSessaoPopUp, setDeleteSessaoPopUp] = useState(false);

    const [editExPopUp, setEditExPopUp] = useState(false);
    const [deleteExPopUp, setDeleteExPopUp] = useState(false);
    const [ordemExPopUp, setOrdemExPopUp] = useState(false);
    const [addExPopUp, setAddExPopUp] = useState(false);


    const [verEx, setVerEx] = useState(false);

    const [itemVisible,setItemVisible] = useState(null);
    const [editVisible,setEditVisible] = useState(null);
    const [deleteVisible,setDeleteVisible] = useState(null);
    const [deleteSessaoVisible,setDeleteSessaoVisible] = useState(null);

    const [id, setId] = useState(null);
    const [idEx, setIdEx] = useState(null);


    const [dashExPopUp, setDashExPopUp] = useState(false);
    const [dashExVisible,setDashExVisible] = useState(null);

    const [infoEx, setInfoEx] = useState({});

    function showDashEx(ex,index){
        setInfoEx(ex);
        setIdEx(index);
        setDashExPopUp(true);
        setDashExVisible(dashExVisible => dashExVisible === index ? index : index);
    }

    function showContent(index){
        setVerEx(true);
        setItemVisible(itemVisible => itemVisible === index ? index : index);
    }

    function editContent(index){
        setEditExPopUp(true);
        setEditVisible(editVisible => editVisible === index ? index : index);
    }

    function deleteSessao(index){
        setDeleteSessaoPopUp(true);
        setDeleteSessaoVisible(deleteSessaoVisible => deleteSessaoVisible === index ? index : index);
    }

    const [sessao, setSessao] = useState({});
    const [sessaoVisible, setSessaoVisible] = useState(null);

    function deleteEx(index){
        setDeleteExPopUp(true);
        setDeleteVisible(deleteVisible => deleteVisible === index ? index : index);
    }

   function showExs(index, item){
        setId(index);
        setSessaoVisible(sessaoVisible => sessaoVisible === index ? index : index);
        setSessao({   
            title: item.title,
            text: item.text,
            exercises: item.exercises
        });
        setSelectedIndex(index);
   };

   return (
       <Card>
        <Stack direction = "row" alignItems="center"  sx={{paddingLeft: 2, paddingTop:1}} m={1}>
            <Typography variant="h4" sx={{paddingRight: 1}}>Sessões Disponíveis para o Utente</Typography>

            <Tooltip title="Associar Nova Sessão ao Utente">
                <Button variant="outlined" endIcon={<AddIcon fontSize="inherit" />}aria-label="add" size="medium" onClick={() => setAddSessaoPopUp(true)}>
                    Associar 
                </Button>
            </Tooltip>
            
            {/* POPUP adicionar nova sessao */}
            <AddNewSession trigger={addSessaoPopUp} data={dadosSessoes} setTrigger={setAddSessaoPopUp}/>

        </Stack>
        
        {/* SESSOES DISPONIVEIS */}
        <Container className="container">
            <Box className="carousel" ref={carousel}>
                <List className={classes.root} component="nav">
                    <Stack direction = "row" alignItems="center">
                        {dadosSessoes.map((itemSessao, index) => {
                            return (
                                <MuiListItem 
                                    button key={index}
                                    selected={selectedIndex === index}
                                    onClick={() => showExs(index, itemSessao)}
                                    >
                                    <ListItemText primary = {
                                        <Stack direction = "column" alignItems="center">
                                            <Typography variant="h6" textAlign={"center"}>{itemSessao.title}</Typography>
                                            <Typography variant="subtitle2" textAlign={"center"}>De 15/07/2022 a 20/08/2022</Typography>

                                            <Box sx={{display:'flex', height: 100, overflow: "hidden", overflowY: "scroll"}}>
                                                <Typography m={1.5} variant="body2">{itemSessao.text}</Typography>
                                            </Box>
                                            
                                            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 1, py: 0.5}}>
                                                <Tooltip title="Ver Exercícios">
                                                    {/*
                                                    <Chip icon={<ArrowCircleDownOutlinedIcon/>} sx={{marginRight:5}} color="primary" label='Ver' clickable onClick ={() => showExs(index, itemSessao)} />
                                                    */}
                                                    <Button size="small" endIcon={<ArrowCircleDownOutlinedIcon/>} variant='contained' sx={{marginRight:1}} onClick ={() => showExs(index, itemSessao)}>
                                                        Ver
                                                    </Button>
                                                </Tooltip>
                                                <Box>
                                                    <Tooltip title="Apagar">
                                                        <IconButton color="primary" onClick ={() => deleteSessao(index)}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    
                                                    {deleteSessaoVisible === index && 
                                                    <DeleteSessaoUtente trigger={deleteSessaoPopUp} sessao={itemSessao} setTrigger={setDeleteSessaoPopUp}/>}
                                                </Box>
                                            </Stack>
                                        </Stack>
                                        } />
                                </MuiListItem>
                                
                            );
                            
                        })}
                   </Stack>
                   
                </List>
                {/*
                <IconButton size="large" onClick={handleLeftClick}>
                    <ArrowCircleLeftSharpIcon fontSize="inherit" />
                </IconButton>
                */}
                {/*
                {dadosSessoes.map((item, index) => {
                    return(
                        <Button key={index} size="large" variant='outlined' >
                            <Typography color="primary" variant="h5">{item.title}</Typography>

                        </Button>
                        
                        <Card className="item" key={index}>
                            <Box sx={{ alignItems:'center', display:'flex', position: 'relative',height: 200}}>
                                <ImageSrc style={{ backgroundImage: `url(${item.url})` }} />
                                <ImageBackdrop className="MuiImageBackdrop-root" /> 
                                <Stack sx={{ alignItems:'center', margin: 1, padding: 0, borderRadius: 0, position: 'absolute',
                                            left: 0,right: 0,top: 0,bottom: 0, display: 'flex',//block
                                            textAlign: 'center',
                                            justifyContent: 'center',
                                            color: theme.palette.common.white,
                                        }}>
                                    <Typography variant="h5">{item.title}</Typography>
                                </Stack>
                            </Box>

                            <Divider margin={2} spacing={2}/>
                                <Box sx={{display:'flex', height: 130, overflow: "hidden", overflowY: "scroll"}}>
                                    <Typography m={1.5} variant="body2">{item.text}</Typography>
                                </Box>
                                
                            <Divider margin={2} spacing={2}/>

                            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 1, py: 0.5}}>
                                <Chip icon={<ArrowCircleDownOutlinedIcon/>} label='Ver' clickable onClick ={() => showExs(index, item)} />
                                <Box>
                                    <Tooltip title="Apagar">
                                        <IconButton onClick ={() => deleteSessao(index)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                    
                                    {deleteSessaoVisible === index && 
                                    <DeleteSessaoUtente trigger={deleteSessaoPopUp} sessao={item} setTrigger={setDeleteSessaoPopUp}/>}
                                </Box>
                            </Stack>
                        </Card>
                        
                    );
                })}
                */}
                {/*
                <IconButton  size="large" onClick={handleRightClick}>
                    <ArrowCircleRightSharpIcon fontSize="inherit" />
                </IconButton>
                */}
            </Box>
        </Container>
        
        {/* VER SESSAO ESCOLHIDA */}
        {sessaoVisible === id && id!=null && 
            <Box m={2}>
                <Stack direction = "row" alignItems="center"spacing={0.5}sx={{paddingLeft: 6, paddingTop:1}}  >
                    <Typography variant="h4" sx={{paddingRight: 2}}>Exercícios — {sessao.title}</Typography>

                    <Tooltip title="Adicionar Exercícios à Sessão">
                        <Button variant="outlined" endIcon={<AddIcon fontSize="inherit" />} aria-label="add" size="medium" onClick = {() => setAddExPopUp(true)}>
                            Adicionar
                        </Button>
                    </Tooltip>
                    
                    {/* ADICIONAR EXERCÍCIOS À SESSAO DO UTENTE */}
                    <AddExsSessaoUtente trigger={addExPopUp} sessao={sessao} setTrigger={setAddExPopUp}/>

                    {/* ALTERAR ORDEM DOS EXERCÍCIOS */}
                    <Tooltip title="Trocar Ordem dos Exercícios">
                        <Button variant="outlined" endIcon={ <ChangeCircleIcon/> } onClick={() => setOrdemExPopUp(true)}>
                           Reordenar
                        </Button>
                    </Tooltip>
                    <ChangeOrderExs trigger={ordemExPopUp} sessao={sessao} setTrigger={setOrdemExPopUp}/>
                </Stack>

                <Container className="container">
                    <Stack direction="row">
                        <IconButton color='primary' className="buttons" size="large" onClick={handleLeftClick}>
                            <ArrowCircleLeftSharpIcon fontSize="inherit" />
                        </IconButton>
                    
                    <Box className="carousel" ref={carousel}>
                        {sessao?.exercises.map((item, index) => {
                            return(
                                <Card className="item" key={index} >
                                    <Box sx={{ alignItems:'center', display:'flex',position: 'relative', height: 200 }}>
                                        <ImageSrc style={{ backgroundImage: `url(${item.url})` }} />
                                        <ImageBackdrop className="MuiImageBackdrop-root" /> 
                                        <Stack sx={{
                                                    alignItems:'center', margin: 1,
                                                    padding: 0, borderRadius: 0,
                                                    position: 'absolute',
                                                    left: 0, right: 0, top: 0, bottom: 0,
                                                    display: 'flex',//block
                                                    textAlign: 'center', justifyContent: 'center',
                                                    color: theme.palette.common.white,
                                                }}>
                                            <Typography variant="h5">{item.name}</Typography>
                                            {item.category.map((item) => {
                                                return (
                                                    <Typography component="span" key={item} variant="body2">{item}</Typography> 
                                                );
                                            })}       
                                        </Stack>
                                    </Box>

                                    <Divider margin={2} spacing={2} />

                                    <Grid container>

                                        <Box sx={{ paddingLeft: 2,paddingTop:0.5, paddingRight:2, paddingBottom:0.5,
                                            display:'flex',alignItems: 'center', textAlign: 'center',flexWrap: 'wrap' }}>
                                        
                                            <Grid item xs={2} md={2} lg={2}>
                                                <RepeatIcon/>
                                            </Grid>

                                            <Grid item xs={10} md={10} lg={10}>
                                                <Typography style ={{paddingLeft: 10,
                                                        display: 'flex', 
                                                        alignItems: 'center', justifyContent: 'spaceBetween',
                                                        flexWrap: 'wrap'  }}
                                                        variant="subtitle2">
                                                    {item.reps} Repetições 
                                                </Typography>

                                                <Typography style ={{paddingLeft: 10,
                                                        display: 'flex', 
                                                        alignItems: 'center', justifyContent: 'spaceBetween',
                                                        flexWrap: 'wrap'  }}
                                                        variant="subtitle2">
                                                    {item.series} Séries
                                                </Typography>
                                            </Grid>

                                            {/* Descanso */}
                                            <Grid item xs={2} md={2} lg={2}>
                                                <AccessTimeIcon />
                                            </Grid>

                                            <Grid item xs={10} md={10} lg={10}>
                                                <Typography style ={{paddingLeft: 10, paddingTop: 7,
                                                        display: 'flex', 
                                                        alignItems: 'center', justifyContent: 'spaceBetween',
                                                        flexWrap: 'wrap'  }}
                                                        variant="subtitle2">
                                                        Descanso Após
                                                </Typography>

                                                <Typography style ={{paddingLeft: 10,
                                                        display: 'flex', 
                                                        alignItems: 'center', justifyContent: 'spaceBetween',
                                                        flexWrap: 'wrap'  }}
                                                        variant="body2">
                                                        Série: {item.descansoAposSerie} seg
                                                </Typography>

                                                <Typography style ={{paddingLeft: 10,
                                                        display: 'flex', 
                                                        alignItems: 'center', justifyContent: 'spaceBetween',
                                                        flexWrap: 'wrap'  }}
                                                        variant="body2">
                                                    Exercício: {item.descansoAposExercicio} seg
                                                </Typography>
                                            </Grid>

                                            {/* tempo */}
                                            <Grid item xs={2} md={2} lg={2}>
                                                <TimerIcon />
                                            </Grid>

                                            <Grid item xs={10} md={10} lg={10}>
                                                <Typography style ={{paddingLeft: 10, paddingTop: 7,
                                                        display: 'flex', 
                                                        alignItems: 'center', justifyContent: 'spaceBetween',
                                                        flexWrap: 'wrap'  }}
                                                        variant="subtitle2">
                                                        Tempo
                                                </Typography>

                                                <Typography style ={{paddingLeft: 10,
                                                        display: 'flex', 
                                                        alignItems: 'center', justifyContent: 'spaceBetween',
                                                        flexWrap: 'wrap'  }}
                                                        variant="body2">
                                                        Limite: {item.tempoLimite} seg
                                                </Typography>

                                                <Typography style ={{paddingLeft: 10,
                                                        display: 'flex', 
                                                        alignItems: 'center', justifyContent: 'spaceBetween',
                                                        flexWrap: 'wrap'  }}
                                                        variant="body2">
                                                    Permanência: {item.tempoManutencao} seg
                                                </Typography>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                       
                                    <Divider margin={1} spacing={1} />

                                    <Stack direction="row"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        sx={{ px: 1, py: 0.5}}>

                                        <Button color='primary' endIcon={<ShowChartIcon/>} 
                                             variant="contained" size="small" onClick = {() => showDashEx(item, index)}
                                        >Histórico </Button>

                                        <Box>
                                            <Tooltip color='primary' title="Instruções">
                                                <IconButton onClick ={() => showContent(index)}>
                                                    <Icon icon={dataViewAlt} />
                                                </IconButton>
                                            </Tooltip>
                                            {itemVisible === index && <VerExPopUp trigger={verEx} content={item} setTrigger={setVerEx}/> }

                                            <Tooltip color='primary' title="Editar">
                                                <IconButton onClick ={() => editContent(index)}>
                                                    <EditIcon/>
                                                </IconButton>
                                            </Tooltip>
                                            {editVisible === index && <EditExerc trigger={editExPopUp} content={item} setTrigger={setEditExPopUp}/> }
                                            
                                            <Tooltip color='primary' title="Apagar">
                                                <IconButton onClick ={() => deleteEx(index)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Tooltip>
                                            {deleteVisible === index && <DeleteExerc trigger={deleteExPopUp} content={item} setTrigger={setDeleteExPopUp}/> }
                                        </Box>
                                    </Stack>
                                </Card>
                            );
                        })}
                    </Box>
                        <IconButton color='primary' className="buttons" size="large" onClick={handleRightClick}>
                                <ArrowCircleRightSharpIcon fontSize="inherit" />
                        </IconButton>
                    </Stack>
                </Container>
            </Box>}

            {dashExVisible===idEx && dashExVisible!=null &&  
                <DashEx m={50} trigger={dashExPopUp} ex={infoEx} setTrigger={setDashExPopUp}/>}
       </Card>
   );
}


